/** Anything at or below this is streamed through the Worker in a single request. */
export const DIRECT_UPLOAD_MAX_BYTES = 90 * 1024 * 1024;

/** Anything larger goes browser/CLI -> R2 directly, via presigned multipart. */
export const FILE_MAX_BYTES = 5 * 1024 * 1024 * 1024;

/** R2 requires every part except the last to be the same size, and >= 5 MiB. */
export const MULTIPART_PART_BYTES = 32 * 1024 * 1024;

/** Presigned part URLs are short-lived; the client refreshes if an upload stalls. */
export const PRESIGN_TTL_SECONDS = 60 * 60;

/** Images above this are served as-is rather than sent through the transform pipeline. */
export const IMAGE_TRANSFORM_MAX_BYTES = 30 * 1024 * 1024;

export const THUMB_WIDTH = 640;

export const SESSION_TTL_SECONDS = 60 * 60 * 24 * 30;

/** How long a pending CLI login stays claimable. */
export const CLI_AUTH_TTL_SECONDS = 10 * 60;
